export const MAIN_CLASS_NAME = 'project-source-settings';
export const BLOCK_GROUP_CLASS_NAME = `${MAIN_CLASS_NAME}__block-group`;
export const CHECKBOX_CONTAINER_CLASS_NAME = `${MAIN_CLASS_NAME}__checkbox-container`;
export const FILTRATION_TOOLBOX_CLASS_NAME = `${MAIN_CLASS_NAME}__filtration-toolbox`;
export const FILTRATION_TEXTAREA_CLASS_NAME = `${MAIN_CLASS_NAME}__filtration-textarea`;
export const FILE_UPLOAD_BUTTON_CLASS_NAME = `${MAIN_CLASS_NAME}__file-upload-button`;
export const APP_SELECT_DROPDOWN_CLASS_NAME = `${MAIN_CLASS_NAME}__app-select-dropdown`;
